import { render, staticRenderFns } from "./EdSocket.vue?vue&type=template&id=b61c7fc2&"
import script from "./EdSocket.vue?vue&type=script&lang=js&"
export * from "./EdSocket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports